import i18next from "src/i18n/config";

import { EventReport } from "@dashboard/devices/types";
import { getEventColors } from "@dashboard/overview/components/EventChartCard/EventChartCard.utils";

import type { EventContentResult, RendererProps } from "./shared/eventTypes";

export const renderUnknownEventContent = ({ event, theme }: RendererProps<EventReport>): EventContentResult => {
    return {
        color: getEventColors(theme)[event.level],
        header: event.eventTypeName,
        component: i18next.t("modals:eventModals.unknownDescription"),
    };
};
